export default {"src":"/_next/static/media/soc-1.64860ad7.svg","height":390,"width":391,"blurWidth":0,"blurHeight":0};